import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAddressCard,
  faLock,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import './HideVehicleHistoryModal.css';
import { toastr } from 'react-redux-toastr';
import { profileRepository } from '../../../../../../../repositories/profileRepository';
import { logout } from '../../../../../../../services/sessionService';

const HideVehicleHistoryModal = ({ show, onHide, history }) => {
  const [checked, setChecked] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleHideHistory = async () => {
    try {
      setLoading(true);

      const response = await profileRepository.hideVehicleHistory();

      if (response.status === 200) {
        toastr.success('Histórico do veículo ocultado com sucesso!');
        setChecked(false);
        onHide();
        await logout('client');
        setTimeout(() => {
          history.push('/client/login');
        }, 1500);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        'Erro ao ocultar histórico do veículo. Tente novamente.';
      toastr.error(errorMessage);
      console.error('Error hiding vehicle history:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon
            icon={faLock}
            style={{ color: '#ff9800', marginRight: 8 }}
          />
          Manter Histórico do Veículo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ fontWeight: 500, marginBottom: 10 }}>
          <span style={{ color: '#222' }}>
            Ter <b>todo o histórico de manutenção em um único lugar</b> ajuda
            você cuidar melhor do seu veículo e valorizar sua revenda no futuro.
          </span>
        </div>
        <div style={{ fontSize: 15, marginBottom: 12 }}>
          Ocultar os dados dos veículos significa:
        </div>
        <ul
          style={{
            color: '#d44',
            fontSize: 15,
            marginBottom: 12,
            listStyleType: 'none',
          }}
        >
          <li>
            <FontAwesomeIcon icon={faTimesCircle} style={{ marginRight: 6 }} />
            Perder o acesso ao histórico de manutenção no Sobre Rodas
          </li>
          <li>
            <FontAwesomeIcon icon={faTimesCircle} style={{ marginRight: 6 }} />
            Dificultar o acompanhamento de revisões e serviços
          </li>
          <li>
            <FontAwesomeIcon icon={faTimesCircle} style={{ marginRight: 6 }} />
            Diminuir o valor percebido do veículo em uma negociação futura
          </li>
        </ul>
        <div style={{ fontWeight: 500, marginBottom: 10 }}>
          Tem certeza que deseja abrir mão desses benefícios de graça,{' '}
          <b>totalmente sem custo para você?</b>
        </div>
        <Form.Check
          type="checkbox"
          id="confirm-hide"
          label="Sim, estou ciente das consequências e desejo ocultar o histórico"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          style={{ marginBottom: 18 }}
        />
        <div className="d-flex gap-2">
          <Button variant="success" className="flex-fill" onClick={onHide}>
            <FontAwesomeIcon icon={faAddressCard} /> Manter o histórico
          </Button>
          <Button
            variant="danger"
            className="flex-fill"
            disabled={!checked}
            onClick={handleHideHistory}
          >
            Ocultar mesmo assim
          </Button>
        </div>
        <div
          className="reset-password-help mt-3"
          style={{ fontSize: 13, color: '#d44', textAlign: 'center' }}
        >
          Em caso de dúvidas ou problemas, contate o{' '}
          <a href="mailto:ouvidoria@sobrerodas.club" style={{ color: '#d44' }}>
            ouvidoria@sobrerodas.club
          </a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default HideVehicleHistoryModal;
